import { useQueryClient } from "@tanstack/react-query";
import { useEffect, useRef, useState } from "react";
import { Link } from "react-router";
import { ApiError, errorMessage, platform } from "../lib/api";
import { useAuth } from "../lib/auth";
import { Alert } from "../components/ui";

// Pagina deschisă din emailul de confirmare: /verify-email?token=… (funcționează și fără autentificare).
export default function VerifyEmail() {
  const { authenticated } = useAuth();
  const qc = useQueryClient();
  const [token] = useState(() => new URLSearchParams(window.location.search).get("token") ?? "");
  const [state, setState] = useState<"working" | "ok" | "error">(token ? "working" : "error");
  const [error, setError] = useState(token ? "" : "Linkul nu este complet.");
  const done = useRef(false); // StrictMode rulează efectul de două ori; linkul se folosește o singură dată
  useEffect(() => {
    history.replaceState(null, "", "/verify-email");
    if (!token || done.current) return;
    done.current = true;
    platform.post("/auth/verify-email", { token })
      .then(() => { setState("ok"); qc.invalidateQueries({ queryKey: ["me"] }); })
      .catch((e) => {
        setState("error");
        setError(e instanceof ApiError && e.problem.code === "token_invalid"
          ? "Linkul nu mai este valabil (a expirat sau a fost deja folosit). Retrimite emailul din panou."
          : errorMessage(e));
      });
  }, [token, qc]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-gradient-to-br from-indigo-50 to-white p-4">
      <div className="w-full max-w-sm text-center">
        <div className="mb-6 text-sm font-bold uppercase tracking-[0.3em] text-brand">shopcore</div>
        <div className="card space-y-4 p-6">
          {state === "working" && <p className="text-sm text-slate-600">Se confirmă adresa…</p>}
          {state === "ok" && (
            <>
              <h1 className="text-xl font-bold">Adresa a fost confirmată</h1>
              <p className="text-sm text-slate-600">Acum poți adăuga domeniul propriu, membri în echipă și chei API.</p>
            </>
          )}
          {state === "error" && <Alert>{error}</Alert>}
          {state !== "working" && (
            <Link to={authenticated ? "/settings" : "/login"} className="inline-block font-semibold text-brand">
              {authenticated ? "Mergi la setări" : "Intră în panou"}
            </Link>
          )}
        </div>
      </div>
    </div>
  );
}
